const sectionTitles: Record<string, string> = {
  '/': 'Обзор',
  '/mail': 'Почта',
  '/tasks': 'Задачи',
  '/projects': 'Проекты',
  '/tenders': 'Тендеры',
  '/calendar': 'Календарь',
  '/contacts': 'Контакты',
  '/suppliers': 'Контакты',
  '/products/catalog': 'Каталог',
  '/products/my': 'Мои товары',
  '/products/stock': 'Остатки',
  '/pc-builder': 'Сборка ПК',
  '/commercial_proposal': 'Коммерческие предложения',
  '/commercial_proposal/requests': 'Запросы КП',
  '/commercial_proposal/settings': 'Настройки КП',
  '/reports': 'Аналитика',
  '/accounting': 'Бухгалтерия',
  '/users': 'Пользователи',
  '/mapping': 'Маппинг',
  '/settings': 'Настройки',
  '/bugs': 'Баг-трекер',
  '/limits': 'Лимиты',
  '/admin/teams': 'Команды',
  '/admin/limits': 'Лимиты AI',
  '/admin/server': 'Нагрузка сервера',
  '/catalog': 'Каталог КТРУ',
  '/login': 'Вход',
}

// Longest path first so e.g. "/tenders/completed" doesn't get matched by "/tenders" alone
// when a more specific entry exists.
const sortedPaths = Object.keys(sectionTitles).sort((a, b) => b.length - a.length)

export function usePageTitle() {
  const route = useRoute()

  return computed(() => {
    const match = sortedPaths.find((p) =>
      p === '/' ? route.path === '/' : route.path === p || route.path.startsWith(p + '/')
    )
    return match ? sectionTitles[match] : ''
  })
}
